import { BaseModel } from "sjs-base-model";

export default class RiskModel extends BaseModel {
    public readonly idInsurance: number = 0;
    public readonly idInsurancePriceList: number = 0;
    public readonly name: string = "";
    public readonly description: string = "";
    public readonly fixedCosts: number = 0;
    public readonly price: number = 0;
    public readonly priceInfo: string = "";
    public readonly tax: number = 0;
    public readonly taxInfo: string = "";
    public readonly total: number = 0;
    public readonly totalApply: number = 0;
    public readonly percentage: number = 0;
    public readonly roundingType: string = "";

    constructor(data: Partial<RiskModel>) {
        super();

        this.update(data);
    }
}
